<app-grid
  stateKey="UserCharts"
  [columnDefs]="columnDefs"
  [rowData]="rowData$ | async"
  [showDelete]="false"
  (save)="save()"
>
</app-grid>
